import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Managed Profiles", -1)

import ProfileList from './ProfileList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileManagePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(ProfileList)
  ]))
}
}

})